import { ComponentPropsWithRef } from 'react';
import { Controller } from 'react-hook-form';

import { InputSelect, InputSelectItem } from '../input/input-select';

type InputSelectControllerProps<T> = Omit<
  ComponentPropsWithRef<typeof InputSelect>,
  'name' | 'defaultValue' | 'options' | 'onChange' | 'onBlur'
> & {
  name: string;
  defaultValue?: T;
  options: InputSelectItem<T>[];
  onChange?: (value: T | null) => void;
  onBlur?: (value: T | null) => void;
};

export function InputSelectController<T>(props: InputSelectControllerProps<T>) {
  const { defaultValue, onChange, onBlur, ...defaultProps } = props;

  return (
    <Controller
      render={({
        field: {
          onChange: onControllerChange,
          onBlur: onControllerBlur,
          value,
        },
        fieldState: { error },
      }) => (
        <InputSelect<T>
          {...defaultProps}
          onChange={e => {
            onControllerChange(e);

            onChange?.(e);
          }}
          onBlur={e => {
            onControllerBlur();

            onBlur?.(e);
          }}
          value={value ?? ''}
          error={error?.message}
        />
      )}
      name={props.name}
      defaultValue={defaultValue}
    />
  );
}
